import { NgModule } from '@angular/core'; 
import { RouterModule, Routes } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { ExecutiveJobsComponent } from './pages/executive-jobs/executive-jobs.component';
import { CsrComponent } from './pages/csr/csr.component';
import { WhatWeDoComponent } from './pages/what-we-do/what-we-do.component';
import { UnsungHeroesComponent } from './pages/reach-out/unsung-heroes/unsung-heroes.component';
import { OrphanageVisitComponent } from './pages/reach-out/orphanage-visit/orphanage-visit.component';
import { HospitalityComponent } from './pages/hospitality/hospitality.component';
import { JoinOurTribeComponent } from './pages/join-our-tribe/join-our-tribe.component';
import { JobDescComponent } from './pages/job-desc/job-desc.component';
import { NewsComponent } from './pages/news/news.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { SinglePostComponent } from './partials/single-post/single-post.component';
import { TermsPageComponent } from './pages/terms-page/terms-page.component';
import { LoaderComponent } from './partials/loader/loader.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';

import { LeadershipComponent } from './pages/leadership/leadership.component';
import { QueenIdiaComponent } from './pages/queen-idia/queen-idia.component';
import { ElitesComponent } from './pages/elites/elites.component';
import { ProjectsPageComponent } from './pages/projects-page/projects-page.component';
import { CeoPageComponent } from './partials/ceo-page/ceo-page.component';
import { ReachOutPageComponent } from './pages/reach-out-page/reach-out-page.component';
import { FigmaBeninCityComponent } from './pages/figma-benin-city/figma-benin-city.component';

const routes: Routes = [
  {
    path: '',
    component: HomePageComponent
  },
  {
    path: 'who-we-are/about-us',
    component: AboutUsComponent
  },
  {
    path: 'who-we-are/csr',
    component: CsrComponent
  },
  {
    path: 'who-we-are/leadership',
    component: LeadershipComponent
  },
  {
    path: 'who-we-are/leadership/ceo',
    component: CeoPageComponent
  },
  {
    path: 'what-we-do',
    component: WhatWeDoComponent
  },
  {
    path: 'reach-out',
    component: ReachOutPageComponent
  },
  {
    path: 'reach-out/2022',
    component: OrphanageVisitComponent
  },
  {
    path: 'reach-out/2023',
    component: UnsungHeroesComponent
  },
  {
    path: 'hospitality',
    component: HospitalityComponent
  },
  {
    path: 'join-our-tribe',
    component: JoinOurTribeComponent,
  },
  {
    path: 'join-our-tribe/:slug',
    component: JobDescComponent,
  },
  {
    path: "projects/Queen-Idia",
    component: QueenIdiaComponent
  },
  {
    path: "projects/Elites-Residence",
    component: ElitesComponent 
  },
  {
    path: "news",
    component: NewsComponent,
  },
  {
    path: "news/:id",
    component: SinglePostComponent
  },
  {
    path: "contact-us",
    component: ContactUsComponent
  },
  {
    path: "T&C",
    component: TermsPageComponent
  },
  {
    path: "Test",
    component: LoaderComponent
  },
  {
    path: "projects",
    component: ProjectsPageComponent
  },
  {
    path: 'benin-city',
    component: FigmaBeninCityComponent
  },
  {
    path: 'executive-jobs',
    component: ExecutiveJobsComponent
  },
  {
    path: "**",
    component: PageNotFoundComponent
  }
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
